const PRODUCT_BOAT_PRO = 'BOAT Pro Landing Page';
const PRODUCT_BUILDER_ARTICLE = 'Builders Lead Form';
const PRODUCT_CAPTAINS_CLUB = 'Captains Club';
const PRODUCT_OWNERS_CLUB = 'Owners Club';

export { PRODUCT_BOAT_PRO, PRODUCT_BUILDER_ARTICLE, PRODUCT_CAPTAINS_CLUB, PRODUCT_OWNERS_CLUB };
